import { inject, Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  selectedCustomerId:any='';
  selectedGroupId:any='';
  selectedCustomerName:any='';
  selectedGroupName:any='';
  private dialogRef: MatDialogRef<any> | null = null;
  public rowData=new Subject();
  public clickSubject = new Subject<void>();
  public cancelDialog= new Subject<void>();
  public resetUploadSubject = new Subject<void>();
  resetUpload$ = this.resetUploadSubject.asObservable();
  constructor() { }
  getDeviceListRowData(data:any)
  {
    console.log(data)
    this.rowData.next(data);
  }
  setDialogRef(ref:MatDialogRef<any>)
{
  this.dialogRef=ref;
}
closeDialog() {
  if (this.dialogRef && this.dialogRef.close) {
    this.dialogRef.close();
    this.dialogRef = null; // Clear the reference after closing
    
  }
}
click$ = this.clickSubject.asObservable();
emitClick(): void 
{
  this.clickSubject.next();
}
cancelDialogWindow$ = this.cancelDialog.asObservable();
emitCancel():void
{
  this.cancelDialog.next();
}
emitResetUpload(): void {
  this.resetUploadSubject.next();
}
}


